import Footer from "../Footer/Footer";
import logo_mynextID from "../../img/logo_mynextID.svg";
import { useNavigate } from "react-router-dom";

interface LeftPanelProps {
  heading: string;
  fontSize?: string;
}

function LeftPanel(props: LeftPanelProps) {
    const navigate = useNavigate();
  return (<>

    <div className="sidebar m-hide">
        <div className="sidebar__title">
            <div className="sidebar__img">
            <div id="logoIcon">
                    <img
                    src={logo_mynextID}
                    alt="logo"
                    className="clickable"
                    onClick={() => {navigate("/")}}
                    />
            </div>
            </div>
            <i className="fa fa-times" id="sidebarIcon" aria-hidden="true"></i>
        </div>

        <div className="col-visual-left-panel">
            <div className="visual-heading">
                <img src="img/issue-icon-default.svg" />
                <h1 style={{ fontSize: props.fontSize }}>{props.heading}</h1>
            </div>
        </div>

     
      <Footer />
    </div>

  </>);
}

export default LeftPanel;

/*
<div className="col-visual w-40">
<div className="visual-heading">
  <img src="img/issue-icon-default.svg" />
  <h1 style={{ fontSize: props.fontSize }}>{props.heading}</h1>
</div>
<FooterText style="m-hide" />
</div>
*/


